import React, { Component } from 'react'
import XLSX from 'xlsx'
import Calendar from 'react-calendar';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
}

const urlA = 'https://backend2.riceinspections.com'
class SpreadSheet extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sDate: '',
            eDate: '',
            isReady: false,
            start: true,
            dupArr : [],
            ws_data :[['ชื่อบริษัท', 'ที่อยู่', 'เบอร์โทร', 'Fax']]
        }
    }
    render() {

        const handleWrite = async () => {
            const fetchData = (sDate, eDate) => {
                return new Promise((resolve) => {
                    fetch(`${urlA}/spreadsheet?sDate=${sDate}&eDate=${eDate}`)
                        .then(res => res.json())
                        .then(value => resolve(value))
                })
            }
            let dupArr = this.state.dupArr
            var wb = XLSX.utils.book_new()
            var ws_name = "SheetJS"
            let data = await fetchData(this.state.sDate, this.state.eDate)

            let ws_data = this.state.ws_data
            data.map((value) => {
                let topic = value['PaperlessDetail']
                if (!Array.isArray(topic['LicenseDetail'])) {
                    topic['LicenseDetail'] = [topic['LicenseDetail']]
                }
                // Array.isArray(topic['LicenseDetail']) ? null : topic['LicenseDetail'] = [topic['LicenseDetail']]
                topic['LicenseDetail'].map((result, idx) => {
                    Object.keys(value).map((inLoop) => {
                        if (inLoop != 'PaperlessDetail') {
                            value[inLoop] = value[inLoop].toString()
                            value[inLoop] = value[inLoop].replace(/\u21b5/g, '')
                            value[inLoop] = value[inLoop].replace(/(?:\r\n|\r|\n)/g, '')
                        }
                    })
                    let indexWord = value['Recipient'].indexOf('จำกัด') + 5
                    let indexWordLast = value['Recipient'].indexOf('Tel')
                    let topicA = value['Recipient'].slice(indexWord, (parseInt(indexWordLast)))

                    let indexWorded = value['Recipient'].indexOf('ห้างหุ้นส่วน')
                    if (indexWorded != -1) {
                        var r = /\d+/;
                        let numberStr = value['Recipient'].match(r)
                        let numberIndex = value['Recipient'].indexOf(numberStr)
                        topicA = value['Recipient'].slice(numberIndex, (parseInt(indexWordLast)))
                    }

                    indexWord = value['Recipient'].indexOf('Tel')
                    indexWordLast = value['Recipient'].indexOf('Fax')
                    let topicB = value['Recipient'].slice(indexWord, (parseInt(indexWordLast)))

                    indexWord = value['Recipient'].indexOf('Fax')
                    let topicC = value['Recipient'].slice(indexWord, (parseInt(value['Recipient'].length)))

                    indexWord = value['Recipient'].indexOf('จำกัด')
                    let topicK = ''
                    if (indexWord != -1) {
                        topicK = value['Recipient'].slice(0, (parseInt(indexWord) + 5))
                        let indexWorded = value['Recipient'].indexOf('ห้างหุ้นส่วน')
                        if (indexWorded != -1) {
                            topicK = value['Recipient'].slice(0, parseInt(value['Recipient'].search(/\d+[/]?\d+?/g)))
                            topicK = topicK.replace('เลขที่', '')
                        }
                    } else {
                        if (value['Recipient'].indexOf('กรมการค้าต่างประเทศ') != -1) {
                            topicK = 'กรมการค้าต่างประเทศ'
                        }
                    }
                    if (!dupArr.find((o) => { return o == topicK })) {
                        dupArr.push(topicK)
                        let temp = [topicK, topicA, topicB, topicC]
                        ws_data.push(temp)
                    }

                })
            })
            var ws = XLSX.utils.aoa_to_sheet(ws_data)
            XLSX.utils.book_append_sheet(wb, ws, ws_name)
            XLSX.writeFile(wb, `${this.state.sDate}To${this.state.eDate}.xlsx`)
        }
        const handleWriteNew = async () => {
            const fetchData = (sDate, eDate) => {
                return new Promise((resolve) => {
                    fetch(`${urlA}/search/?sDate=${sDate}&eDate=${eDate}`)
                        .then(res => res.json())
                        .then(value => resolve(value))
                })
            }
            let dupArr = this.state.dupArr
            var wb = XLSX.utils.book_new()
            var ws_name = "SheetJS"
            let data = await fetchData(this.state.sDate, this.state.eDate)

            let ws_data = this.state.ws_data
            
            data.map((value) => {
                let topic = value['PaperlessDetail']
                if (!Array.isArray(topic['LicenseDetail'])) {
                    topic['LicenseDetail'] = [topic['LicenseDetail']]
                }
                // Array.isArray(topic['LicenseDetail']) ? null : topic['LicenseDetail'] = [topic['LicenseDetail']]
                topic['LicenseDetail'].map((result, idx) => {
                    Object.keys(value).map((inLoop) => {
                        if (inLoop != 'PaperlessDetail') {
                            value[inLoop] = value[inLoop].toString()
                            value[inLoop] = value[inLoop].replace(/\u21b5/g, '')
                            value[inLoop] = value[inLoop].replace(/(?:\r\n|\r|\n)/g, '')
                        }
                    })
                    let indexWord = value['Recipient'].indexOf('จำกัด') + 5
                    let indexWordLast = value['Recipient'].indexOf('Tel')
                    let topicA = value['Recipient'].slice(indexWord, (parseInt(indexWordLast)))

                    let indexWorded = value['Recipient'].indexOf('ห้างหุ้นส่วน')
                    if (indexWorded != -1) {
                        var r = /\d+/;
                        let numberStr = value['Recipient'].match(r)
                        let numberIndex = value['Recipient'].indexOf(numberStr)
                        topicA = value['Recipient'].slice(numberIndex, (parseInt(indexWordLast)))
                    }

                    indexWord = value['Recipient'].indexOf('Tel')
                    indexWordLast = value['Recipient'].indexOf('Fax')
                    let topicB = value['Recipient'].slice(indexWord, (parseInt(indexWordLast)))

                    indexWord = value['Recipient'].indexOf('Fax')
                    let topicC = value['Recipient'].slice(indexWord, (parseInt(value['Recipient'].length)))

                    indexWord = value['Recipient'].indexOf('จำกัด')
                    let topicK = ''
                    if (indexWord != -1) {
                        topicK = value['Recipient'].slice(0, (parseInt(indexWord) + 5))
                        let indexWorded = value['Recipient'].indexOf('ห้างหุ้นส่วน')
                        if (indexWorded != -1) {
                            topicK = value['Recipient'].slice(0, parseInt(value['Recipient'].search(/\d+[/]?\d+?/g)))
                            topicK = topicK.replace('เลขที่', '')
                        }
                    } else {
                        if (value['Recipient'].indexOf('กรมการค้าต่างประเทศ') != -1) {
                            topicK = 'กรมการค้าต่างประเทศ'
                        }
                    }
                    if (!dupArr.find((o) => { return o == topicK })) {
                        dupArr.push(topicK)
                        let temp = [topicK, topicA, topicB, topicC]
                        ws_data.push(temp)
                    }

                })
            })
            this.setState({
                dupArr : dupArr,
                ws_data : ws_data,
            })
            // var ws = XLSX.utils.aoa_to_sheet(ws_data)
            // XLSX.utils.book_append_sheet(wb, ws, ws_name)
            // XLSX.writeFile(wb, `${this.state.sDate}To${this.state.eDate}.xlsx`)
        }
        const prepareState = (a, b) => {
            this.setState({
                sDate: a,
                eDate: b,
                isReady: true
            })
        }
        const injectState = () => {
            this.setState({ isReady: false })
        }
        const handleTimeSelect = (value) => {
            const startDate = value[0].toString()
            const endDate = value[1].toString()
            const getMonth = (monthStr) => {
                return new Date(monthStr + '-1-01').getMonth() + 1
            }

            const extractDate = (stringDate) => {
                let dateDay = stringDate.slice(8, 10)
                let dateMonth = getMonth(stringDate.slice(4, 7)).toString()
                let dateYear = stringDate.slice(11, 15)
                if (dateMonth < 10) dateMonth = `0${dateMonth}`
                return [dateDay, dateMonth, dateYear]
            }
            const limitDateRange = (sDate, eDate) => {
                let [startDay, startMonth, startYear] = sDate
                let [endDay, endMonth, endYear] = eDate
                if (endYear == startYear) {
                    if (startMonth == endMonth && Math.abs(parseInt(endDay) - parseInt(startDay)) <= 120) {
                        return true
                    } else if (Math.abs(startMonth - endMonth) >= 1) {
                        if (Math.abs((parseInt(endDay) + 30) - parseInt(startDay)) <= 120) {
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }

            }
            let sDate = extractDate(startDate)
            let eDate = extractDate(endDate)
            if (true) {
                prepareState(`${sDate[2]}-${sDate[1]}-${sDate[0]}`, `${eDate[2]}-${eDate[1]}-${eDate[0]}`)
            } else {
                injectState()
            }
        }
        return (
            <div>
                <div style={{ height: `${window.innerHeight}px` }}>
                    <div style={{ padding: '4%' }}>
                        <div className='columns'>
                            <div className='column'>
                                <Calendar
                                    onChange={(data) => { handleTimeSelect(data) }}
                                    onClickDay={
                                        () => {
                                            this.setState({ start: !this.state.start })
                                        }}
                                    selectRange={true}
                                />
                                <br /><br />
                                {(() => {
                                    if (((this.state.isReady == true) && (this.state.start == true))) {
                                        return <a className='button is-success' disabled={false}
                                            onClick={handleWrite}> Download </a>
                                    }
                                    else {
                                        return <a className='button is-success' disabled={true}
                                        > Download </a>
                                    }
                                })()}
                                                                {(() => {
                                    if (((this.state.isReady == true) && (this.state.start == true))) {
                                        return <a className='button is-success' disabled={false}
                                            onClick={handleWriteNew}> Accumulate </a>
                                    }
                                    else {
                                        return <a className='button is-success' disabled={true}
                                        > Accumulate </a>
                                    }
                                })()}
                            </div>
                            <div className='column'>
                                {(() => {
                                    if (this.state.start) {
                                        return <p className='title is-3'>กรุณาเลือกวันเริ่มต้น</p>
                                    } else {
                                        return <p className='title is-3'>เลือกวันสิ้นสุด</p>
                                    }
                                })()}
                                {(() => {
                                    if (this.state.isReady) {
                                        return <p className='title is-4'> สามารถเลือกระยะเวลาได้สูงสุด 7 วัน</p>
                                    } else {
                                        return <p className='title is-4' style={{ color: 'red' }}> ไม่สามารถเลือกมากกว่า 7 วัน</p>
                                    }
                                })()}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default SpreadSheet